/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-21 09:58:40
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-21 10:46:39
 */
import { Cookies } from '@package/service'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import localeEn from './locale/en_US.js'
import localeZh from './locale/zh_CN.js'

Vue.use(VueI18n)

/**
 * 浏览器默认语言
 * @type {string}
 */
const navigatorLang = navigator.language.replace('-', '_')

const defaultLang = Cookies.get('language') || navigatorLang

const messages = {
  en_US: {
    ...localeEn,
    ...elementEnLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh_CN: {
    ...localeZh,
    ...elementZhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}
const i18n = new VueI18n({
  locale: defaultLang,
  messages
})
/**
 * 默认语言
 * @type {*[]}
 */
i18n.languages = [
  { value: 'zh_CN', name: '简体中文' },
  { value: 'en_US', name: 'English' }
]
/**
 * 切换语言
 * @param newLocale
 */
i18n.setLocale = (newLocale) => {
  i18n.locale = newLocale
  Cookies.set('language', newLocale)
}
export default i18n
